module.exports = __webpack_public_path__ + "static/media/Action.48f80b77.svg";